import { floorNumber } from "./number";

export const isArray = <T = unknown>(value: T | T[]): boolean =>
	Array.isArray(value);

export const toArray = <T = unknown>(value: T | T[]): T[] =>
	Array.isArray(value) ? value : [value];

// https://stackoverflow.com/a/46161940
export const shuffle = <T = unknown>(array: Array<T>): Array<T> => {
	const shuffled = array.slice();
	for (let i = shuffled.length - 1; i > 0; i--) {
		const rand = floorNumber(Math.random() * (i + 1));
		[shuffled[i], shuffled[rand]] = [shuffled[rand], shuffled[i]];
	}
	return shuffled;
};
